<div class="message">
  <div class="insurance-image"></div>
  <p class="insurance-image-text"><%%= I18n.insurance.callouts.details_help %></p>
</div>
